import React, { useState } from 'react';
import { formatPrice } from '../../utils/priceUtils';
import { formatDate } from '../../utils/formatDate';

const PropertySpecifications = (specifications) => {

    const furnishingTypes = {
        1: "Fully Furnished",
        2: "Semi-Furnished",
        3: "Unfurnished"
    };
    const brokerageCharge = {
        1: "Yes",
    };
    const brokerageNegotiable = {
        1: "Yes",
    };

    const areaFields = ["built_up_area", "carpet_area","sizes","plot_area"];
    
    return (
        <>
<ul className="p-0 m-0 amenities-box mt-2">
    {Object.entries(specifications.specifications)
        .filter(([_, value]) => {
            // Skip null, empty string, empty array, or array with only empty/null values
            return value !== null && value !== "" &&
                   !(Array.isArray(value) && value.every(v => v === null || v === ""));
        })
        .map(([key, value]) => {
            const formattedKey = key.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase());
            let displayValue = value;

            if (Array.isArray(value)) {
                if (key === "bhk") {
                    displayValue = value.join(", "); // Comma-separated for BHK
                } else if (areaFields.includes(key)) {
                    displayValue = value.join(" - ") + " Sq.Ft."; // Hyphen-separated for area
                } else {
                    displayValue = value.join(", "); // Default for other arrays
                }

                if (key === "price") {
                    const buildup = parseInt(specifications?.specifications?.buildup_area?.[0], 10) || 1; // Get first buildup_area
                    const propertyPrice = parseInt(value[0], 10) || 0; // Get first property_price
                    
                    displayValue = propertyPrice
                        ? `₹ ${formatPrice((propertyPrice / buildup).toFixed(2))}`
                        : "";
                  
                }
            } else {
                // Convert furnishing type
                if (key === "furnishing") {
                    displayValue = furnishingTypes[value] || value;
                }
                if (key === "brokerage_charge") {
                    displayValue = brokerageCharge[value] || 'No';
                }
                if (key === "brokerage_amount") {
                    displayValue = `₹ ${formatPrice(value)}` || 'No';
                }
                if (key === "brokerage_negotiable") {
                    displayValue = brokerageNegotiable[value] || 'No';
                }
                
                // if (key === "price" && Array.isArray(value)) {
                   
                //     const buildup = parseInt(specifications?.specifications?.buildup_area?.[0], 10) || 1; // Get first buildup_area
                //     const propertyPrice = parseInt(value[0], 10) || 0; // Get first property_price
                    
                //     displayValue = propertyPrice
                //         ? `₹ ${formatPrice((propertyPrice / buildup).toFixed(2))}`
                //         : "";
                // }
                
                if (key === "your_floor") {
                    displayValue = value.split(",").map(floor => {
                        const numValue = parseInt(floor.trim(), 10); // Convert to number
                        if (numValue === 0) {
                            return "Ground";
                        } else {
                            const suffixes = ["th", "st", "nd", "rd"];
                            const v = numValue % 100;
                            const suffix = (v >= 11 && v <= 13) ? "th" : suffixes[(numValue % 10 < 4) ? numValue % 10 : 0];
                            return `${numValue}${suffix}`;
                        }
                    }).join(", ");
                }

                if (["available_from", "possession_date", "launch_date"].includes(key)) {
                    displayValue = formatDate(value, "MMM-YYYY"); // Output: "Dec-2024"
                }
                
                if (key === "sizes") {
                    displayValue = Array.isArray(value) && value.length > 0
                        ? value.length > 1 
                            ? `${value[0]} - ${value.at(-1)}`  // Show "first - last" if multiple values
                            : `${value[0]}`  // Show only first if single value
                        : '';
                }

                // Append "Sq.Ft." for area fields
                if (areaFields.includes(key)) {
                    displayValue = `${value} Sq.Ft.`;
                }
            }
            const formattedValue = 
            typeof displayValue === "string"
                ? displayValue.replace(/_/g, " ").replace(/\b\w/g, char => char.toUpperCase())
                : displayValue; // Keep numbers unchanged
            return (
                <li key={key}>
                    <div className="detail">
                        <h5 className="detail-title">{formattedKey === 'Price' ? 'Price/Sq.Ft.' : formattedKey}</h5>
                        <p className="detail-text">{formattedValue}</p>
                    </div>
                </li>
            );
        })}
</ul>



        </>
    );
};

export default PropertySpecifications;
